export { default as Ratings } from './Ratings'
